module.exports = __webpack_public_path__ + "static/media/veido-test.67fc5e13.png";